import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import cesPopupImage from "@asset/ces/ces-popup.png";

const PopupWrapper = styled.div`
  position: absolute;
  top: 80px;
  right: 20px;
  width: calc(100% - 40px);
  max-width: 700px;
  z-index: 1000;
  cursor: pointer;
`;

const PopupImage = styled.img`
  width: 100%;
  height: auto;
`;

const CloseButton = styled.button`
  position: absolute;
  width: 36px;
  height: 36px;
  top: 0px;
  right: 0px;
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  background-color: #ffffff4d;
  color: white;
  &:hover {
    background-color: #71ac324d;
    color: #71ac32;
  }
  &:active {
    background-color: #ffffff33;
    color: white;
  }
`;

const CesPopup = ({ onClose }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/ces");
  };

  return (
    <PopupWrapper>
      <PopupImage
        src={cesPopupImage}
        alt="CES 2025 Popup"
        onClick={handleClick}
      />
      <CloseButton onClick={onClose}>×</CloseButton>
    </PopupWrapper>
  );
};

export default CesPopup;
